<template>
  <div class="product-item">
    <!-- <el-popover placement="top-start" trigger="hover">
        <el-image style="width: 400px; height: 400px;" :src="getFirstImageSrc(product.productImages)" fit="cover"></el-image>
        <el-image style="width: 100%; height: 300px;" :src="getFirstImageSrc(product.productImages)" fit="contain" :preview-src-list="getImageSrcList(product.productImages)" slot="reference"></el-image>
    </el-popover> -->

    <el-image style="width: 100%; height: 320px;" :src="getFirstImageSrc(product.productImages)" fit="contain"
      :preview-src-list="getImageSrcList(product.productImages)" slot="reference"></el-image>

    <!-- <el-image style="width: 100%; height: 200px;" :src="getFirstImageSrc(product.productImages)" fit="contain"
      :preview-src-list="getImageSrcList(product.productImages)"></el-image> -->
    <!-- 标签 -->
    <div class="tag-wrapper">
      <el-tag class="tag-item" v-if="product.productPrize" size="small">{{ product.productPrize }}元</el-tag>
      <el-tag class="tag-item" type="info" size="small">{{ getProductStatusName(product.productStatus) + (product.productVip == 1 ? "(VIP)" : "") }}</el-tag>
      <el-tag class="tag-item" type="warning" size="small">{{ getImageCount(product.productImages) }}张图</el-tag>
      <el-dropdown>
        <el-tag class="tag-item" size="small" style="cursor: pointer;">更多操作</el-tag>
        <el-dropdown-menu slot="dropdown">
          <!-- <el-dropdown-item @click.native="downloadAllImages(getImageSrcList(product.productImages), product.productAppraisal)">批量下载</el-dropdown-item> -->
          <el-dropdown-item v-if="product.productVideo" @click.native="videoOpen(product.productVideo)">视频播放</el-dropdown-item>
          <el-dropdown-item @click.native="dropDownClick(product.productId, 2, false)"
            v-if="product.productStatus < 5 && product.productVip == 0">图片代卖</el-dropdown-item>
          <el-dropdown-item @click.native="dropDownClick(product.productId, 3, false)"
            v-if="product.productStatus < 5 && product.productVip == 0">实物代卖</el-dropdown-item>
          <el-dropdown-item @click.native="dropDownClick(product.productId, 5, false)"
            v-if="product.productStatus < 5 && product.productVip == 0">钱币锁定</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 视频播放 -->
    <el-dialog title="视频播放" :visible.sync="videoLayer" width="50%" :close-on-click-modal="false">
        <div class="block">
            <video controls :src="getImageSrc(videoSrc)" style="max-width: 50vw; max-height: 50vh; display: block; margin: 0px auto;"></video>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="videoLayer = false">关 闭</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import imageMixin from "@/mixins/image-mixin.js"
import enumMixin from "@/mixins/enum-mixin.js"
import axios from "axios"

export default {
  mixins: [imageMixin, enumMixin],
  name: 'ProductComponent',
  props: {
    product: {
      type: Object,
      default: {}
    }
  },
  data: function () {
    return {
      videoLayer: false,
      videoSrc: "",
    }
  },
  methods: {
    videoOpen: function(videoSrc) {
        this.videoLayer = true;
        this.videoSrc = videoSrc;
    },
    getStatusName: function (status) {
      let name = "";
      for (let i = 0; i < this.statusArray.length; i++) {
        if (this.statusArray[i].value == status) {
          name = this.statusArray[i].label;
          break;
        }
      }
      return name;
    },
    downloadSingleImage: function (url, name) {
      axios({
        url,
        method: "GET",
        responseType: 'blob'
      }).then(res => {
        const blob = new Blob([res.data]);
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = name;
        a.click();
        URL.revokeObjectURL(url);
      });
    },
    downloadAllImages: function (urls, code) {
      this.$message.warning(code + "正在批量下载，请稍后...");
      for (let i = 0; i < urls.length; i++) {
        if (!code) {
          code = (new Date()).getTime();
        }
        this.downloadSingleImage(urls[i], code + "-" + (i + 1) + ".jpg");
      }
    },
    dropDownClick: function(id, type, appraisal) {
      this.$emit("dropDownClick", id, type, appraisal);
    }
  }
}
</script>

<style>
.product-item {
  background-color: #FFFFFF;
  width: 320px;
  height: 357px;
  margin-right: 12px;
  margin-bottom: 12px;
  border: 1px solid #DCDFE6;
}

.tag-wrapper {
  width: 320px;
  display: flex;
  justify-content: center;
}

.tag-item {
  margin-left: 5px;
}
</style>
